// Features
export const maintenanceScreenWeb = 'maintenance_screen_web'
export const directToMobile = 'direct_to_mobile_landing_page'
export const mocOnboardingEnabled = 'mighty_oak_card_onboarding_enabled'
export const registrationServiceResumeFunnel = 'registration_service_resume_funnel'
export const passions = 'passions'
export const dynamicPricingScreen = 'dynamic_pricing_screen'
export const cardOrderReviewCorrection = 'dynamic_funnels_card_order_review'
export const referralCaptureMOCInterest = 'referrals_affiliates_capture_moc_interest'
export const mocDDWaiver = 'moc_dd_waiver'

// Experiments
export const webToAppV2Experiment = 'direct_to_mobile_landing_page_test_v2'
export const pricingScreenExperiment = 'gme_gx55_pricingscreenredesignv1_web'
export const bitcoinInRegistrationExperiment = 'bitcoin_in_registration'
export const ssnCopyUpdateExperiment = 'ssn_copy_update_v1_test'
